import { startCase } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { getTool, getSelectedMaterials, getMaterials } from 'store/selectors'
import tools from './tools'

interface StateProps {
  currentTool: string
  selectedMaterials: Array<number | string>
  materials: { [key: string]: ReduxStore.Materials.Data.IMaterial }
}

type Props = StateProps

const ToolOptions: React.FC<Props> = props => {
  const { currentTool, selectedMaterials, materials } = props
  
  // Determine which tool options to show
  let toolToShow = currentTool
  
  // If no tool is selected but shapes are selected, show options for the selected shape type
  if (!currentTool || currentTool === 'select') {
    if (selectedMaterials.length > 0) {
      // Get the shape type of the first selected material
      const firstSelectedMaterial = materials[selectedMaterials[0]]
      if (firstSelectedMaterial) {
        const shapeType = firstSelectedMaterial.shape
        // Check if this shape type has options available
        // @ts-ignore
        if (tools[shapeType] && tools[shapeType].options) {
          toolToShow = shapeType
        }
      }
    }
  }
  
  // @ts-ignore
  if (tools && tools[toolToShow] && tools[toolToShow].options) {
    // @ts-ignore
    const { options: ToolOptionsComponent } = tools[toolToShow]
    return (
      <div>
        <h3>{startCase(toolToShow)} options</h3>
        <ToolOptionsComponent />
      </div>
    )
  }
  return null
}

const mapStateToProps = (state: ReduxStore.State) => ({
  currentTool: getTool(state),
  selectedMaterials: getSelectedMaterials(state),
  materials: getMaterials(state)
})

export default connect(mapStateToProps)(ToolOptions)
